import { SalesProps } from '../../interfaces/interfaces';
// import { FaTrash } from 'react-icons/fa';

import './styles.scss';

export function Sale({ author, quant, refer, color, date, onClick }: SalesProps) {
  return (
    <div className="sale ">
      <div className="itens-container">
        <div className="user-info">
          <img src={author.avatar} alt={author.name} />
          <span>{author.name}</span>
        </div>
        <div className="itens-sales">
          <span className="title">NÚMERO:</span>
          {quant}
        </div>
        <div className="itens-sales">
          <span className="title">REF.:</span>
          {refer}
        </div>
        <div className="itens-sales">
          <span className="title">COR:</span>
          {color}
        </div>
        <div className="itens-sales">
          <span className="date-title">{date}</span>
          <button onClick={onClick} className="itens-sales-btn--remove"></button>
        </div>
      </div>
    </div>
  );
}